module.exports = __webpack_public_path__ + "static/media/WHY_WBN_SOLUTIONS.d056a4c4.png";